import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import '../../Roles/roles.css';
import { StationV2 } from '../../../../types/dashboardV2';

interface DetachStationDialogProps {
  station: StationV2 | null;
  organizationName: string;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  isSubmitting: boolean;
  errorMessage?: string;
}

export const DetachStationDialog = ({
  station,
  organizationName,
  onClose,
  onConfirm,
  isSubmitting,
  errorMessage,
}: DetachStationDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={!!station} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('dashboard.organizationStations.detachTitle')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {t('dashboard.organizationStations.detachConfirm', {
            idTag: station?.idTag,
            name: organizationName,
          })}
        </Typography>
        {errorMessage && (
          <Typography variant="body2" color="error" sx={{ mt: 2 }} role="alert">
            {errorMessage}
          </Typography>
        )}
      </DialogContent>
      {/* Plain buttons on the dashboard's own classes: the shared MUI theme
          is built for the dark mobile app and renders <Button> unreadable
          on a light Dialog Paper. */}
      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <button type="button" className="secondary-action-btn" onClick={onClose} disabled={isSubmitting}>
          {t('dashboard.common.cancel')}
        </button>
        <button
          type="button"
          className="danger-action-btn"
          onClick={() => void onConfirm()}
          disabled={isSubmitting}
        >
          {t('dashboard.organizationStations.detach')}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default DetachStationDialog;
